// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ff2bc0b","453":"5b50ab50","654":"bb56adeb"}[chunkId] + ".chunk.js";
};